import {ApplicationEvent} from './application-event.model';
import {ApplicationEventType} from '../constants';
import {
  GaTrackingEventAction,
  GaTrackingEventCategory,
  GaTrackingEventName
} from '~shared/modules/ga-tracking/constants';

export class FlixmediaBrandPageApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.FlixMediaContentViewed;
  event = GaTrackingEventName.FlixMediaBrandPageView;
  category = GaTrackingEventCategory.Interaction;
  label = '';
  action: GaTrackingEventAction.FlixMediaBrandPageView;

  constructor() {
    this.label = 'https://www.metro.de/marktplatz/brand/dyson';
  }

  getPayload(): any {
    return {
      type: this.type,
      event: this.event,
      category: this.category,
      label: this.label,
      action: this.action,
      gtmCustom: {
        category: this.category
      }
    };
  }
}
